import {AbstractEvent} from "@/modules/base/events";
import {Suspension} from "@/modules/competitions/entity";

export class BeforePlayerSuspendedEvent extends AbstractEvent {
  constructor(
    public suspension: Suspension,
  ) {
    super();
  }
}